interface IWordlist {
    chunk?: number
    language?: string
}
export class Wordlist {
    private readonly _language: string;

    private _wordlist: string[] = [];

    constructor(private props: IWordlist) {
        this._language = props.language ?? "en-gb";
    }

    async initialise() {
        const wordlist = await import(`@data/wordlist/${this._language}.json`);

        this._wordlist = wordlist.legal.split(/,/);
    }

    legal(word: string) {
        return this._wordlist.includes(word.toLowerCase());
    }
}